// @flow

import { observer } from "mobx-react";
import React from "react";
import Slider from "react-slick";

import GlobalSettingsStore from "app/stores/GlobalSettingsStore";

import Video from "app/models/Video";
import VideoCard from "app/components/VideoCard/VideoCard";

import "./VideoCardCarousel.scss";

type Props = {
    videos: any[],
    serverTime: any
};

function ArrowNext(props: any) {
    const { onClick } = props;
    return (
        <div
            className="VideoCardCarousel__arrow VideoCardCarousel__arrow--next"
            onClick={onClick}
        >
            <i className="fa fa-chevron-right" />
        </div>
    );
}

function ArrowPrev(props: any) {
    const { onClick } = props;
    return (
        <div
            className="VideoCardCarousel__arrow VideoCardCarousel__arrow--prev"
            onClick={onClick}
        >
            <i className="fa fa-chevron-left" />
        </div>
    );
}

const sliderSettings = {
    arrow: true,
    infinite: true,
    nextArrow: <ArrowNext />,
    prevArrow: <ArrowPrev />,
    centerMode: true,
    responsive: [
        { breakpoint: 768, settings: { slidesToShow: 1 } },
        { breakpoint: 992, settings: { slidesToShow: 2 } },
        { breakpoint: 100000, settings: { slidesToShow: 3 } }
    ]
};

@observer
export default class VideoCardCarousel extends React.Component<Props> {
    videos: Video[];

    constructor(props: Props) {
        super(props);
        this.videos = Video.makeArray(this.props.videos);
    }

    render() {
        const cards = this.videos.map((video: Video) =>
            this.renderVideoCard(video)
        );

        return (
            <div className="VideoCardCarousel">
                <div className="VideoCardCarousel__background VideoCardCarousel__background--left" />
                <Slider {...sliderSettings}>{cards}</Slider>
                <div className="VideoCardCarousel__background VideoCardCarousel__background--right" />
            </div>
        );
    }

    renderVideoCard(video: Video) {
        return (
            <div key={video.rowid} className="HomeView__video-card-container">
                <VideoCard
                    video={video}
                    items={video.items}
                    serverTime={this.props.serverTime}
                    theme={GlobalSettingsStore.videoCardTheme}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/VideoCardCarousel/VideoCardCarousel.js